import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./slices/counterSlice";
import { orderSlice } from "./slices/orderSlice";
import { productSlice } from "./slices/productSlice";
import { uploadSlice } from "./slices/uploadSlice";
import { userSlice } from "./slices/userSlice";
import { storeSlice } from "./slices/storeSlice";
import { categorySlice } from "./slices/categorySlice";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    userSignin: userSlice.reducer,
    products: productSlice.reducer,
    product: productSlice.reducer,
    productVariant: productSlice.reducer,
    productUpdate: productSlice.reducer,
    createProduct: productSlice.reducer,
    deleteProduct: productSlice.reducer,
    newProduct: productSlice.reducer,
    uploadProductImages: uploadSlice.reducer,
    listOrders: orderSlice.reducer,
    singleOrder: orderSlice.reducer,
    deliverOrder: orderSlice.reducer,
    deleteOrder: orderSlice.reducer,
    listUsers: userSlice.reducer,
    singleUser: userSlice.reducer,
    updateUser: userSlice.reducer,
    deleteUser: userSlice.reducer,
    createUser: userSlice.reducer,
    createStore: storeSlice.reducer,
    listStores: storeSlice.reducer,
    singleStore: storeSlice.reducer,
    activeStore: storeSlice.reducer,
    categories: categorySlice.reducer,
  },
});
